import { Alert, Box, FormControl, InputLabel, MenuItem, Select, Tooltip, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import apis from "../../api"
import { apiResult, getUserSession,  } from "../../Utils/Common"
import { AccountBalanceOutlined, AttachMoneyOutlined, TimesOneMobiledataOutlined, UpdateOutlined } from "@mui/icons-material"


const CoursePackageSelect = (props) => {
    const {defaultValue,onChange,name,label,categoryid} = props
    const [_coursepackages,setCoursePackages] = useState()    
    const [error,setError] = useState()
    getUserSession(apis)
    let loading = false
    useEffect(()=>{    
        if(loading)      return
        loading = true
        CoursePackageLoader(categoryid,apis,(data)=>setCoursePackages(data),setError)       
    },[])
    return <FormControl fullWidth sx={props.sx}>
        <InputLabel id="demo-simple-select-autowidth-label">{label ?label:"Select course package"}</InputLabel>
        <Select labelId="demo-simple-select-autowidth-label" disabled = {props.disabled}
            id="course_package"
            onChange={(e) => { 
                let id = e.target.value;
                let choose = false
                if(id>=0) {
                    for(let i=0;i<_coursepackages.length;i++) {
                        if(_coursepackages[i].id == id) {
                            onChange && onChange(name,_coursepackages[i])
                            choose = true
                            break
                        }
                    }
                }
                if(!choose) {
                    onChange && onChange(name,undefined)
                }
            }}
            defaultValue={defaultValue || -1}
            label={label ?label:"Select course package"}
        >
            <MenuItem value={-1}>All</MenuItem>
            {_coursepackages && _coursepackages.map((p, idx) => {   
                let dd1 = <Box sx={{display:"flex"}}>                                                                        
                <Typography sx={{ cursor: "pointer"}} >{p.course_category?.name}</Typography>/
                <Typography sx={{ cursor: "pointer"}} >{p.course_id > 0 ? p.course?.name : "*"}</Typography>
                <Typography sx={{ flex: '1 1 15%' }} variant="h6" component="div" ></Typography>
                <Tooltip title="Unit price before tax"><AttachMoneyOutlined fontSize={"small"} sx={{ml:2}} /></Tooltip><Typography>{p.price}</Typography>
                {p.billtype == 0 ?<Tooltip title="Per lesson"><TimesOneMobiledataOutlined fontSize={"small"} sx={{ml:2,mr:0.5}} /></Tooltip>:<Tooltip title="Per hour"><UpdateOutlined fontSize={"small"} sx={{ml:2,mr:0.5}} /></Tooltip>}<Typography >{p.minutes} minutes</Typography>
                <Tooltip title="Tax rate"><AccountBalanceOutlined fontSize="small" sx={{ml:2,mr:0.5}} /></Tooltip><Typography>{p.tax * 100}%</Typography>
            </Box>             
                // let dd = p.course_category.name + "/" + (p.course_id>0?p.course.name:"*") + " " + (p.billtype == 0?("$"+p.price+"/"+(p.minutes/60).toFixed(1)+"h/lesson"):"$"+p.price+"/h") + " tax("+(Number(p.tax)*100)+"%)"
                return (!categoryid || categoryid == 0 || (categoryid > 0 && p.category_id == categoryid)) && <MenuItem key={idx} value={p.id}>{dd1}</MenuItem>
            })}
        </Select>
        {error&&<Alert variant="error" onClose={()=>setError()}>{error}</Alert>}
    </FormControl>
}
const CoursePackageLoader = (category_id,apis,callback,errCallback) => {
    apis.coursepackageGet(category_id,1).then(ret => {
        apiResult(ret, data => {                
            callback(data)
        },errCallback)
    })
}

export {CoursePackageLoader,CoursePackageSelect}